import React from 'react';
import useDefaultCallToAction from 'hooks/useDefaultCallToAction';
import Copy from './Copy';
import ContentfulCallToAction from 'components/Contentful/ContentfulCallToAction';

import { Container } from './styles';

const CopyContainer = ({
  callToAction,
  handleCopyHover,
  slideInfo,
  slideshowStarted,
  handleItemClick,
  copy,
  items,
}) => {
  const defaultCallToAction = useDefaultCallToAction();

  return (
    <Container>
      <Copy
        slideInfo={slideInfo}
        slideshowStarted={slideshowStarted}
        handleItemClick={handleItemClick}
        copy={copy}
        items={items}
        handleCopyHover={handleCopyHover}
      />
      {callToAction && (
        <ContentfulCallToAction {...(callToAction ? callToAction : defaultCallToAction)} />
      )}
    </Container>
  );
};

export default CopyContainer;
